/**
 * Feature flag client: fetches flags from the backend and normalises to a flat map.
 * Used by FeatureFlagProvider; call fetchFeatureFlags() when org context is available.
 */

import { featureFlagsAPI } from '../services/api';

/**
 * Fetch feature flags for the current organisation (requires auth + org).
 * @returns {Promise<Record<string, boolean>>} Normalised { [key]: boolean } map.
 */
export async function fetchFeatureFlags() {
  const data = await featureFlagsAPI.getFlags();
  const raw = data ?? {};
  if (typeof raw !== 'object' || raw === null || Array.isArray(raw)) {
    return {};
  }
  const flags = {};
  for (const [key, value] of Object.entries(raw)) {
    if (typeof key === 'string' && typeof value === 'boolean') {
      flags[key] = value;
    }
  }
  return flags;
}
